import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/", end: true },
  { label: "影视作品", to: "/category/films" },
  { label: "明星人物", to: "/category/stars" },
  { label: "网络话题", to: "/category/topics" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [mobileKeyword, setMobileKeyword] = useState("");

  const goSearch = (value: string) => {
    const q = value.trim();
    setMenuOpen(false);
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `whitespace-nowrap px-3 py-2 text-sm transition-colors ${
      isActive
        ? "text-primary-600 font-medium"
        : "text-foreground-700 hover:text-primary-600"
    }`;

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="hidden items-center justify-between bg-primary-950 px-8 py-1.5 text-xs text-background-100/80 md:flex">
        <span>影视 · 人物 · 话题，一站式娱乐资讯聚合平台</span>
        <span>权威资讯 · 及时更新 · 深度关联</span>
      </div>

      <div className="flex h-16 items-center gap-4 px-4 md:h-[68px] md:px-8">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-bold text-background-50">
            巨
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
              巨乳
            </span>
            <span className="mt-0.5 text-[10px] tracking-[0.2em] text-foreground-400">
              娱乐资讯网
            </span>
          </span>
        </Link>

        <nav className="hidden flex-1 items-center justify-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className={linkClass}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form
          className="ml-auto hidden w-64 items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-1.5 md:flex"
          onSubmit={(event) => {
            event.preventDefault();
            goSearch(keyword);
          }}
        >
          <i className="ri-search-line text-sm text-foreground-400" aria-hidden="true"></i>
          <input
            value={keyword}
            onChange={(event) => setKeyword(event.target.value)}
            placeholder="搜索影视 / 明星 / 话题"
            aria-label="站内搜索"
            className="w-full bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
          />
        </form>

        <div className="ml-auto flex items-center gap-2 md:hidden">
          <button
            type="button"
            aria-label="打开搜索"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 cursor-pointer"
          >
            <i className="ri-search-line text-lg" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 cursor-pointer"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <form
            className="mb-3 flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-2"
            onSubmit={(event) => {
              event.preventDefault();
              goSearch(mobileKeyword);
            }}
          >
            <i className="ri-search-line text-sm text-foreground-400" aria-hidden="true"></i>
            <input
              value={mobileKeyword}
              onChange={(event) => setMobileKeyword(event.target.value)}
              placeholder="搜索影视 / 明星 / 话题"
              aria-label="站内搜索"
              className="w-full bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
            />
          </form>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm transition-colors ${
                    isActive
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}